module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABK0lEQVR4AWOgC/hPNEDRsHfv3pUrV379+hVZxbdv31atWrV79250DQ8fPgwJCXF2crp05QpI3a37327cAzKu3bjh4+OTmZn54MEDFA3Hjh3z9fXt6ev7//PX7eSqYzwGJ7n17sWV/v/xa/Gypd7e3ocOHULRALHk07ev92asOsogc4Zdew+34QYG5Td98z9+/XL//n00JyFAfe6Utcw6K4WslPVy+FUyl8fXI+Qwbfj29Uv3ihMscmns+kUMxpUMSrlT5u/7+uUzxAPofggKCpoyedKPX39Da1Yym1SwGpeHli/9+vPv6lUrAwMD0f1w7969xMREoL8vX7oE5F6/9/La3ZcgxvVrYWHh5eXld+/eRXfSrl27li1bhhkPy5cv37lzJ4RLekwPSgAAJ2Busnb3gmEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/KR.png
// module id = 1185
// module chunks = 0